export default "__VITE_ASSET__BSfuGppB__"